import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { Logo, Wordmark } from "@/components/Logo";
import { confirmSubscription } from "@/lib/api";

export default function Confirm() {
  const { token } = useParams();
  const [state, setState] = useState("working"); // working | done | error
  const [note, setNote] = useState("");

  useEffect(() => {
    confirmSubscription(token)
      .then((res) => {
        setNote(res.data?.already ? "You were already confirmed — welcome all the same." : "");
        setState("done");
      })
      .catch((e) => {
        if (e?.response?.status === 409) {
          setNote(e.response.data.detail);
        }
        setState(e?.response?.status === 404 || e?.response?.status === 409 ? "error" : "done");
      });
  }, [token]);

  return (
    <div data-testid="confirm-page" className="min-h-screen flex flex-col">
      <header className="px-6 pt-8">
        <Link to="/" className="inline-flex items-center gap-3" aria-label="AuDHDSpaces home">
          <Logo size={30} />
          <Wordmark />
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-20">
        {state === "working" && <p className="text-moss animate-pulse">One gentle moment…</p>}

        {state === "done" && (
          <div className="text-center max-w-md">
            <div className="h-20 w-20 mx-auto rounded-full bg-sage-100 flex items-center justify-center mb-8">
              <Check className="h-8 w-8 text-sage-700" strokeWidth={2.5} />
            </div>
            <h1 className="font-serif text-4xl text-ink mb-5">You're in.</h1>
            <p className="text-moss leading-relaxed mb-2">
              Your first letter arrives on a Monday morning — short, soft, and written for your answers.
            </p>
            {note && <p className="text-moss text-sm italic mb-2">{note}</p>}
            <p className="text-moss leading-relaxed mb-10">
              A small welcome note is on its way to your inbox now.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
              <Link
                to={`/preferences/${token}`}
                data-testid="confirm-preferences-link"
                className="rounded-full bg-sage-700 px-8 py-3.5 text-sm font-semibold text-paper hover:bg-sage-900 transition-colors duration-300"
              >
                See your answers
              </Link>
              <Link to="/" className="link-quiet text-sm">
                Back to the quiet home page
              </Link>
            </div>
          </div>
        )}

        {state === "error" && (
          <div className="text-center max-w-md">
            <h1 className="font-serif text-3xl text-ink mb-4">This link went quiet.</h1>
            <p className="text-moss mb-8">
              {note || "We couldn't find that subscription link."} The bottom of any letter from
              us carries a fresh one.
            </p>
            <Link to="/" className="link-quiet">Back to the home page</Link>
          </div>
        )}
      </main>
    </div>
  );
}
